import { useState } from 'react'

import { Avatar, Box, Icon, Tag, Text, Tooltip } from '@factorialco/deprecated-design-system'
import { JoinOrganicChannelsMutation } from 'generated/resources/graphql'

type IntegrationsJoinOrganicChannelDetails = NonNullable<
  NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<JoinOrganicChannelsMutation['integrationsJoinMutations']>['listIntegrationsjoinOrganicChannel']
      >['organicChannel']
    >['channels']
  >[0]
>

interface Props {
  channel: IntegrationsJoinOrganicChannelDetails
}

export const JobPostingStandardPortalDetails = ({ channel }: Props) => {
  const [tooltipOpen, setTooltipOpen] = useState(false)

  return (
    <Box
      key={channel.slug}
      border={{ all: { color: 'grey200', style: 'solid', width: 's1' } }}
      paddingY="s16"
      paddingX="s24"
      borderRadius={{ all: 'abs010' }}
      justifyContent="spaceBetween"
      alignItems="center"
      flexDirection="row"
    >
      <Box gap="s12" flexDirection="row" alignItems="center">
        <Avatar label="" url={channel.logoUrl} size="s32" />
        <Text.Normal weight="semibold">{channel.name}</Text.Normal>
        {channel.description && (
          <Box onMouseEnter={() => setTooltipOpen(true)} onMouseLeave={() => setTooltipOpen(false)}>
            <Tooltip.Alt attachment="top left" open={tooltipOpen} label={channel.description}>
              <Icon.Medium icon="info-circle-line" />
            </Tooltip.Alt>
          </Box>
        )}
      </Box>

      <Box
        borderRadius={{ all: 'abs010' }}
        border={{ all: { color: 'grey200', style: 'solid', width: 's1' } }}
      >
        <Tag icon="person" iconColor="grey800" type="transparent" leftItem="icon">
          {channel.applicationsCount}
        </Tag>
      </Box>
    </Box>
  )
}
